import MyLogbook from "./pages/Mylogbook";
import Logbooks from "./pages/Logbooks";
import LogbookDetails from "./pages/LogbookDetails";
import LogbookResultPage from "./pages/LogbookResultPage";
import MySupervisorRequestsPage from "./pages/MySupervisorRequestsPage";
import SupervisorDashboard from "./pages/SupervisorDashboard";
import SupervisorLogbookReview from "./pages/SupervisorLogbookReview";
import AdminLogbooksPage from "./pages/AdminLogbooksPage";
import AdminDietLogbooksPage from "./pages/AdminDietLogbooksPage";
import AdminLogbookDetailPage from "./pages/AdminLogbookDetailPage";
import AdminAssessmentDietsPage from "./pages/AdminAssessmentDietsPage";
import AdminAssessmentDietDetailsPage from "./pages/AdminAssessmentDietDetailsPage";
import AssessorAssessmentDietsPage from "./pages/AssessorAssessmentDietsPage";
import AssessorAssessmentLogbooksPage from "./pages/AssessorAssessmentLogbooksPage";
import AdminLogbookResultApprovalPage from "./pages/AdminLogbookResultApprovalPage";

export const logbookRoutes = [
  // Admin logbook management: diet hub -> per-diet list -> review detail.
  {
    path: "/admin/logbooks",
    element: <AdminLogbooksPage />,
    roles: ["admin"],
  },
  // Logbook Assessment: assessment-diet list -> detail (assessors + assignment).
  {
    path: "/admin/logbook-assessment",
    element: <AdminAssessmentDietsPage />,
    roles: ["admin"],
  },
  {
    path: "/admin/logbook-assessment/:id",
    element: <AdminAssessmentDietDetailsPage />,
    roles: ["admin"],
  },
  // Board — approve/release assessed logbook results to members.
  {
    path: "/admin/logbook-result-approval",
    element: <AdminLogbookResultApprovalPage />,
    perms: ["logbook_result.approve"],
  },
  {
    path: "/admin/logbooks/diet/:dietId",
    element: <AdminDietLogbooksPage />,
    roles: ["admin"],
  },
  // Assessor-facing assessment: my diets -> my logbooks in a diet (grade).
  {
    path: "/assessor/assessments",
    element: <AssessorAssessmentDietsPage />,
    roles: ["assessor", "fellow", "member", "past president"],
  },
  {
    path: "/assessor/assessments/:id",
    element: <AssessorAssessmentLogbooksPage />,
    roles: ["assessor", "fellow", "member", "past president"],
  },
  {
    path: "/admin/logbooks/:id",
    element: <AdminLogbookDetailPage />,
    roles: ["admin"],
  },
  {
    path: "/logbook",
    element: <MyLogbook />,
    roles: [
      "admin",
      "member",
      "probationer",
      "executive",
      "assessor",
      "chairman",
      "fellow",
      "student",
      "technician",
    ],
  },
  {
    path: "/logbooks",
    element: <Logbooks />,
    roles: ["admin"],
  },
  {
    path: "/supervisor",
    element: <SupervisorDashboard />,
    roles: [
      "member",
      "executive",
      "assessor",
      "chairman",
      "fellow",
      "past president",
    ],
  },
  {
    path: "/supervisor/logbooks/:logbookId",
    element: <SupervisorLogbookReview />,
    roles: ["member", "executive", "assessor", "chairman", "fellow"],
  },

  {
    path: "/logbook/:id/result",
    element: <LogbookResultPage />,
    roles: [
      "admin",
      "member",
      "probationer",
      "executive",
      "assessor",
      "chairman",
      "fellow",
      "student",
      "technician",
    ],
  },
  {
    path: "/logbook/:id",
    element: <LogbookDetails />,
    roles: [
      "admin",
      "member",
      "probationer",
      "executive",
      "assessor",
      "chairman",
      "technician",
    ],
  },
  {
    path: "/logbook/supervisor-requests",
    element: <MySupervisorRequestsPage />,
    roles: ["member", "executive", "assessor", "chairman", "fellow"],
  },
];
